// Tinted-surface token pair per tone, for the few kit components that take colors
// as props and apply them inline (`IconBox`'s `bg` / `iconColor`). Scoped CSS
// stays the default everywhere else; this exists only for that prop-driven seam.
//
// Module-local rather than shared with listingRequest's `toneSurface`: that one is
// part of that module's private constants, and reaching across would couple two
// feature modules through their internals.
import type { LifecycleTone } from '../constants/propertyLifecycle'

export interface ToneSurface {
  bg: string
  fg: string
}

const TONE_SURFACES: Record<LifecycleTone, ToneSurface> = {
  neutral: { bg: 'var(--p-surface-100)', fg: 'var(--p-text-muted-color)' },
  primary: { bg: 'var(--p-primary-50)', fg: 'var(--p-primary-600)' },
  success: { bg: 'var(--p-success-50)', fg: 'var(--p-success-600)' },
  warning: { bg: 'var(--p-warning-50)', fg: 'var(--p-warning-600)' },
  danger: { bg: 'var(--p-danger-50)', fg: 'var(--p-danger-600)' },
  info: { bg: 'var(--p-info-50)', fg: 'var(--p-info-600)' },
}

export function toneSurfaceOf(tone: LifecycleTone): ToneSurface {
  return TONE_SURFACES[tone]
}
